import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { AppBar, Button, IconButton, Toolbar, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useAuth } from '../contexts/AuthContext';
import { formatWithOptions } from 'date-fns/fp';
import { fr } from 'date-fns/locale'
import { capitalize } from './Utils';
import { useState } from 'react';

const DashboardNavbarRoot = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[3]
}));

// const useStyles = makeStyles((theme) => {
//   return {
//     date: {
//       flexGrow: 1
//     },
//   }
// });

export const DashboardNavbar = (props) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  const { onSidebarOpen, ...other } = props;

  const {currentUser, logout} = useAuth();

  // const classes = useStyles();

  return (
    <>
      <DashboardNavbarRoot
        sx={{
          left: {
            lg: 220
          },
          width: {
            lg: 'calc(100% - 220px)'
          }
        }}
        {...other}>
        <Toolbar
          disableGutters
          sx={{
            minHeight: 64,
            left: 0,
            px: 2
          }}
        >
          <IconButton
            onClick={onSidebarOpen}
            sx={{
              display: {
                xs: 'inline-flex',
                lg: 'none'
              }
            }}
          >
            <MenuIcon fontSize="small" />
          </IconButton>
          {/* <Typography color="#374151" className={classes.date}> */}

          {
            isMobile ?
            null :              
            <Typography color="#374151" sx={{ flexGrow: 1 }}>
              {capitalize(formatWithOptions({ locale: fr }, 'EEEE d MMMM Y')(new Date()))}
            </Typography>
          }
          <Typography color="#374151">[ {currentUser.email} ]</Typography>
          <Button onClick={logout}>Déconnexion</Button>
        </Toolbar>
      </DashboardNavbarRoot>
    </>
  );
};

DashboardNavbar.propTypes = {
  onSidebarOpen: PropTypes.func
};
